module.exports = __webpack_public_path__ + "static/img/share1.2791342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share1.jpg
// module id = ReMG
// module chunks = 1